export default "__VITE_ASSET__1daf3b73__"